import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { PureComponent } from 'react';
import { PrismAsyncLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import { normalizeLanguage } from '../supportedLanguages';
import { applyTheme } from '../themes/themeBuilder';

var Code = /*#__PURE__*/function (_PureComponent) {
  _inherits(Code, _PureComponent);

  var _super = _createSuper(Code);

  function Code() {
    _classCallCheck(this, Code);

    return _super.apply(this, arguments);
  }

  _createClass(Code, [{
    key: "render",
    value: function render() {
      var _applyTheme = applyTheme(this.props.theme),
          inlineCodeStyle = _applyTheme.inlineCodeStyle;

      var language = normalizeLanguage(this.props.language);
      var props = {
        language: language,
        PreTag: this.props.preTag,
        style: this.props.codeStyle || inlineCodeStyle,
        codeTagProps: this.props.codeTagProps
      };
      return /*#__PURE__*/React.createElement(SyntaxHighlighter, _extends({
        "data-code-lang": this.props.language,
        "data-testid": this.props.testId
      }, props), this.props.text);
    }
  }]);

  return Code;
}(PureComponent);

_defineProperty(Code, "defaultProps", {
  theme: {},
  codeTagProps: {},
  preTag: 'span'
});

export { Code as default };